
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              焯峯工程顧問有限公司
            </h3>
            <p className="text-sm text-gray-300 mb-2">CF ENGINEERING CONSULTANTS LIMITED</p>
            <p className="text-gray-300 mb-4">
              專業提供香港工程服務，包括村屋僭建物申報及適任技術人員註冊服務，確保符合屋宇署監督制度要求。
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">服務項目</h4>
            <ul className="space-y-2 text-gray-300">
              <li>村屋僭建物申報及安全檢驗</li>
              <li>T1 適任技術人員註冊</li>
              <li>T3 適任技術人員註冊</li>
              <li>屋宇署工程監督服務</li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">聯絡資訊</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                <span>香港九龍新蒲崗大有街3號萬迪廣場15樓J室</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <span>+852 9189 8819</span>
              </div>
              <div className="flex items-center">
                <i className="ri-whatsapp-line mr-2"></i>
                <a 
                  href="https://wa.me/85291898819"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-green-400 transition-colors cursor-pointer"
                >
                  WhatsApp: +852 9189 8819
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <span>info@cfengineering.com.hk</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 焯峯工程顧問有限公司. 版權所有. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
};
